import lf from 'lovefield'

export function const_engins (schemaBuilder) {
  schemaBuilder.createTable('const_engins')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('const_famillesengins_id', lf.Type.INTEGER)
      .addColumn('description', lf.Type.STRING)
      .addPrimaryKey(['id'])
      .addUnique('code_engin', ['code'])
      // .addIndex('constFamillesengins_id', ['constFamillesengins_id']);
}

/*
CREATE TABLE IF NOT EXISTS `const-engins` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(8) NOT NULL,
  `nom` varchar(30) NOT NULL,
  `const-famillesengins_id` int(11) NOT NULL,
  `description` text NOT NULL,
  PRIMARY KEY (`id`),
  UNIQUE KEY `code_engin` (`code`),
  UNIQUE KEY `id` (`id`),
  KEY `const-famillesengins_id` (`const-famillesengins_id`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=35 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constEngins.schema.js